const mobileMenu = document.querySelector<HTMLDialogElement>("[data-mobile-menu]");
const mobileMenuOpen = document.querySelector<HTMLButtonElement>(
  "[data-mobile-menu-open]",
);
const mobileMenuClose = mobileMenu?.querySelector<HTMLButtonElement>(
  "[data-mobile-menu-close]",
);
const siteHeader = document.querySelector<HTMLElement>("[data-site-header]");

let headerIsScrolled: boolean | undefined;

function updateHeaderScrollState(): void {
  if (!siteHeader) return;

  let nextState = window.scrollY > 16;
  if (nextState === headerIsScrolled) return;

  headerIsScrolled = nextState;
  siteHeader.dataset.scrolled = String(nextState);
}

updateHeaderScrollState();
window.addEventListener("scroll", updateHeaderScrollState, { passive: true });

function closeMobileMenu(): void {
  if (!mobileMenu?.open) return;
  mobileMenu.close();
}

mobileMenuOpen?.addEventListener("click", () => {
  if (!mobileMenu) return;
  mobileMenu.showModal();
  document.documentElement.classList.add("overflow-hidden");
});

mobileMenuClose?.addEventListener("click", closeMobileMenu);

mobileMenu?.addEventListener("click", (event) => {
  if (event.target === mobileMenu) closeMobileMenu();
});

mobileMenu?.addEventListener("close", () => {
  document.documentElement.classList.remove("overflow-hidden");
  mobileMenuOpen?.focus();
});

const desktopFlyouts = Array.from(
  document.querySelectorAll<HTMLDetailsElement>("[data-nav-flyout]"),
);

function closeDesktopFlyout(flyout: HTMLDetailsElement): void {
  flyout.open = false;
}

desktopFlyouts.forEach((flyout) => {
  const panel = flyout.querySelector<HTMLElement>("[data-nav-flyout-panel]");
  const submenuItems = Array.from(
    flyout.querySelectorAll<HTMLElement>("[data-nav-submenu-item]"),
  );
  let submenuCloseTimer: number | undefined;

  const setSubmenuOpen = (isOpen: boolean): void => {
    window.clearTimeout(submenuCloseTimer);
    if (panel) panel.dataset.submenuOpen = String(isOpen);
  };

  const scheduleSubmenuClose = (): void => {
    window.clearTimeout(submenuCloseTimer);
    submenuCloseTimer = window.setTimeout(() => {
      const submenuIsActive = submenuItems.some(
        (item) => item.matches(":hover") || item.matches(":focus-within"),
      );

      if (!submenuIsActive) setSubmenuOpen(false);
    }, 150);
  };

  submenuItems.forEach((item) => {
    item.addEventListener("pointerenter", () => setSubmenuOpen(true));
    item.addEventListener("pointerleave", scheduleSubmenuClose);
    item.addEventListener("focusin", () => setSubmenuOpen(true));
    item.addEventListener("focusout", scheduleSubmenuClose);
  });

  flyout.addEventListener("toggle", () => {
    if (!flyout.open) {
      setSubmenuOpen(false);
      return;
    }

    desktopFlyouts.forEach((otherFlyout) => {
      if (otherFlyout !== flyout) closeDesktopFlyout(otherFlyout);
    });
  });
});

document.addEventListener("pointerdown", (event) => {
  const target = event.target;
  if (!(target instanceof Node)) return;

  desktopFlyouts.forEach((flyout) => {
    if (flyout.open && !flyout.contains(target)) closeDesktopFlyout(flyout);
  });
});

document.addEventListener("keydown", (event) => {
  if (event.key !== "Escape") return;

  const openFlyout = desktopFlyouts.find((flyout) => flyout.open);
  if (!openFlyout) return;

  event.preventDefault();
  closeDesktopFlyout(openFlyout);
  openFlyout.querySelector<HTMLElement>("summary")?.focus();
});
